"use client";

import { c as _c } from "react/compiler-runtime";
import { SectionBoundary } from "@/features/home-v2/states/SectionBoundary";
import FinanceFlows from "./FinanceFlows";
import { D4Classic } from "./NftDesigns";
import type { NftView } from "./nftView";
import { useNftFinance } from "./useNftFinance";
import "@/features/artists/profile/artist-profile.css";
import "@/features/collections/detail/panels.css";
import "@/features/collections/detail/vitrine/vitrine-panels.css";
import "@/features/auctions/v2/single/auction-single.css";
import "@/features/auctions/v2/single/designs/designs.css";
import "./nft-single.css";

/**
 * THE SINGLE NFT, in v2. The server page is unchanged (404 vs load failure,
 * the viewer's profile for ownership, the rate table for the schema,
 * metadata, JSON-LD); every commerce rule is the legacy board's, gathered in
 * `useNftFinance`, and the five money paths are the legacy flows mounted as
 * before (`FinanceFlows`). Design «کلاسیک» — the live page's own order (chosen from
 * the design review).
 */
function Body(t0) {
  const $ = _c(8);
  const {
    v
  } = t0;
  const f = useNftFinance(v.finance);
  let t1;
  if ($[0] !== f || $[1] !== v) {
    t1 = <D4Classic v={v} f={f} />;
    $[0] = f;
    $[1] = v;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== f) {
    t2 = <FinanceFlows f={f} />;
    $[3] = f;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="v2-page as-page ap-page ns-page">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}

/** Its own boundary, as the legacy commerce section had: a throw here does not take the route with it. */
export default function NftSingle(t0) {
  const $ = _c(7);
  const {
    v
  } = t0;
  const isFa = v.lang === "fa";
  const t1 = isFa ? "\u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F" : "This page didn't load";
  const t2 = isFa ? "\u0628\u0631\u0627\u06CC \u062A\u0644\u0627\u0634 \u062F\u0648\u0628\u0627\u0631\u0647 \u0631\u0648\u06CC \u062F\u06A9\u0645\u0647\u200C\u06CC \u0632\u06CC\u0631 \u0628\u0632\u0646\u06CC\u062F." : "Use the button below to try again.";
  const t3 = isFa ? "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F" : "Try again";
  let t4;
  if ($[0] !== v) {
    t4 = <Body v={v} />;
    $[0] = v;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = <SectionBoundary title={t1} description={t2} retryLabel={t3}>{t4}</SectionBoundary>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}